var React = require('react');

function ByeInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_154","data-name":"Rectangle 154","width":"28","height":"24","rx":"2","fill":"#fdfdfd","key":0}),React.createElement("path",{"id":"Combined-Shape","d":"M5,6H19a2.081,2.081,0,0,1,2,2.154v9.692A2.081,2.081,0,0,1,19,20H5a2.081,2.081,0,0,1-2-2.154V8.154A2.081,2.081,0,0,1,5,6ZM18.144,7.981,12,11.544,5.856,7.981a.724.724,0,0,0-1.016.328.84.84,0,0,0,.3,1.094l6.5,3.769a.7.7,0,0,0,.711,0l6.5-3.769a.84.84,0,0,0,.3-1.094A.724.724,0,0,0,18.144,7.981Z","transform":"translate(2 -1.113)","fill":"#253155","fillRule":"evenodd","key":1})]);
}

ByeInline.defaultProps = {"id":"Group_1750","data-name":"Group 1750","width":"28","height":"24","viewBox":"0 0 28 24"};

module.exports = ByeInline;

ByeInline.default = ByeInline;
